import React, { useEffect, useState } from "react";
import { useSearch } from "../../Contexts/SearchContext";
import Card from "../../Card";
import "./SearchResults.scss";

const SearchResults = ({ emptyResults }) => {
  const { state, dispatch } = useSearch();
  const {
    searchTerm,
    filteredResults,
    resultsToShow_mobile,
    resultsToShow_tablet,
    resultsToShow_desktop,
    resultsToShowStepSize_mobile,
    resultsToShowStepSize_tablet,
    resultsToShowStepSize_desktop,
    componentPath,
    componentType,
  } = state;

  const [pageDepth, setPageDepth] = useState(1);

  useEffect(() => {
    setPageDepth(1);
  }, [searchTerm]);

  const updateResultsToShow = () => {
    dispatch({
      type: "UPDATE_RESULTS_TO_SHOW_MOBILE",
      payload: resultsToShow_mobile + resultsToShowStepSize_mobile,
    });
    dispatch({
      type: "UPDATE_RESULTS_TO_SHOW_TABLET",
      payload: resultsToShow_tablet + resultsToShowStepSize_tablet,
    });
    dispatch({
      type: "UPDATE_RESULTS_TO_SHOW_DESKTOP",
      payload: resultsToShow_desktop + resultsToShowStepSize_desktop,
    });

    showMoreLinkAnalytics();
  };

  function showMoreLinkAnalytics() {
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.linkClick,
      linkDetails: {
        clickName: 'Product Finder Show more',
        clickType: 'Link',
        clickDestination: '',
        clickLocation: 'Main Container',
        searchDetails: {
          searchTerm: searchTerm,
          type: 'Product Finder',
          pageDepth: pageDepth,
        }
      }
    });
    setPageDepth(pageDepth + 1);
  }

  let showMoreLinkClasses = "";

  const getCardData = (item) => {
    const cardItem = {};

    const { Fields } = item;
    const {
      pagePath,
      pageTitle_product,
      pageDescription_product,
      textCTALink_product,
      textCTAText_product,
      buttonCTAText_product,
      buttonCTALink_product,
      cardTagsAndLabels_product,
      formattedPageTags,
      byLabel_product,
      imagePath_product,
      showInCustomerSuccess,
      buttonCTAText_customer,
      buttonCTALink_customer,
    } = Fields;
    const tags = JSON.parse(cardTagsAndLabels_product?.Value);
    const mapCategories = () => {
      const categories = JSON.parse(formattedPageTags?.Value);
      return categories.map((item) => {
        return { label: item.label, tagId: item.tagId };
      });
    };

    const categoryArray = mapCategories();
    const cardLabel = tags[0]?.label || "";

    cardItem.pagePath = pagePath.Value;
    cardItem.label = cardLabel;
    cardItem.title = pageTitle_product?.Value;
    cardItem.author = byLabel_product?.Value;
    cardItem.description = pageDescription_product?.Value;
    cardItem.categories = categoryArray;
    cardItem.buttonCTALink = buttonCTALink_product?.Value;
    cardItem.buttonCTAText = buttonCTAText_product?.Value;
    cardItem.textCTALink = textCTALink_product?.Value;
    cardItem.textCTAText = textCTAText_product?.Value;
    cardItem.customerSuccess = true;
    cardItem.imagePath_product = imagePath_product?.Value;
    cardItem.showInCustomerSuccess = showInCustomerSuccess?.Value;
    cardItem.buttonCTAText_customer = buttonCTAText_customer?.Value;
    cardItem.buttonCTALink_customer = buttonCTALink_customer?.Value;
    return cardItem;
  };

  // renders
  return (
    <>
      <div className="cmp-product-finder-results__top-border"></div>
      <div
        id="search-top"
        className="search-results product-finder-search-results-section"
        data-cludo-search-result="Product Finder"
        data-cludo-query={state.searchTerm}
        data-cludo-page={state.currentPage}
        data-cludo-total-results={state.totalResults}
        data-cludo-query-id={state.cludoQueryId}
        data-cludo-referral-url={document.referrer}
      >
        {filteredResults?.map((result, index) => {
          let showHideClasses = "";
          showMoreLinkClasses = "";
          if (index >= resultsToShow_mobile) {
            showHideClasses += " hidden-mobile";
            showMoreLinkClasses += " show-mobile";
          }

          if (index >= resultsToShow_tablet) {
            showHideClasses += " hidden-tablet";
            showMoreLinkClasses += " show-tablet";
          }

          if (index >= resultsToShow_desktop) {
            showHideClasses += " hidden-desktop";
            showMoreLinkClasses += " show-desktop";
          }

          return (
            <Card
              key={index}
              {...getCardData(result)}
              showHide={showHideClasses}
              componentPath={componentPath}
              clickTrackingEnabled={true}
              componentType={componentType}
              index={index}
            />
          );
        })}
        <div className="cmp-card-wrapper dummy-card hidden-mobile"></div>
        <div className="cmp-card-wrapper dummy-card hidden-mobile hidden-tablet"></div>
      </div>
      {filteredResults && showMoreLinkClasses !== "" && (
        <div
          className={`product-finder-show-more-link-container${showMoreLinkClasses}`}
        >
          <a
            href={void 0}
            className="product-finder-show-more-link"
            onClick={updateResultsToShow}
          >
            Show more
          </a>
        </div>
      )}
      {!filteredResults.length && (
        <div
          className="empty-results"
          dangerouslySetInnerHTML={{ __html: emptyResults }}
        />
      )}
    </>
  );
};

export default SearchResults;
